import styled from 'styled-components';

const Hr = styled.hr`
  margin: 30px 0 15px;
  border: 0;
  border-top: 1px solid var(--border-color);
`;

export default Hr;
